<template>
  <div id="zcard">
    <!--导航区-->
    <ul class="nav flex-box">
      <li
        :class="{ac:see === index}"
        v-for="(n, index) in nav"
        :key="index"
        @click="see = index"
      >{{ n }}(0)</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "zorder",
  data() {
    return {
      nav: ["未使用", "已使用", "已过期"],
      see: 0
    };
  },
  methods: {
    //获取个人信息
    // getInfo() {
    //   let _this = this;
    //   let data = {};
    //   this.$jsonp(this.$apis("me"), data, res => {
    //     _this.info = res.data.data.result;
    //   });
    // },
  },
  mounted: function() {
    this.$tool.setTitle("我的优惠券");
  }
};
</script>








<style scoped>
.nav {
  background: white;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  font-size: 13px;
  color: #999;
  align-items: center;
  padding: 10px 0;
  z-index: 2;
}
.nav li {
  width: 25%;
  text-align: center;
}
.nav .ac {
  position: relative;
  font-size: 18px;
  color: #333;
}
.nav .ac::after {
  position: absolute;
  content: "";
  width: 10px;
  height: 4px;
  border-radius: 3rem;
  background: #333;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
}

</style>
